var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4473 20.6719V22.5H11.7812V20.9355L15.9385 16.4443C16.3721 15.9521 16.7148 15.5244 16.9668 15.1611C17.2188 14.7979 17.3975 14.4697 17.5029 14.1768C17.6143 13.8779 17.6699 13.5938 17.6699 13.3242C17.6699 12.9316 17.5996 12.5889 17.459 12.2959C17.3184 11.9971 17.1133 11.7656 16.8438 11.6016C16.5801 11.4375 16.2549 11.3555 15.8682 11.3555C15.4404 11.3555 15.0742 11.4551 14.7695 11.6543C14.4707 11.8477 14.2422 12.1172 14.084 12.4629C13.9316 12.8086 13.8555 13.2041 13.8555 13.6494H11.5264C11.5264 12.8936 11.7021 12.2051 12.0537 11.584C12.4053 10.957 12.9092 10.4561 13.5654 10.0811C14.2217 9.70605 15.001 9.51855 15.9033 9.51855C16.7822 9.51855 17.5264 9.66504 18.1357 9.95801C18.7451 10.2451 19.208 10.6553 19.5244 11.1885C19.8408 11.7217 19.999 12.3574 19.999 13.0957C19.999 13.5059 19.9316 13.9102 19.7969 14.3086C19.6621 14.707 19.4717 15.1025 19.2256 15.4951C18.9854 15.8818 18.6982 16.2744 18.3643 16.6729C18.0303 17.0713 17.6582 17.4785 17.248 17.8945L14.752 20.6719H20.4473Z",
    fill: "#F79009"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F79009"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 32,
    width: 1,
    height: 24,
    fill: "#F79009"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.95280a67d441ef2840ee5dacda32b6fe.svg";
export { ForwardRef as ReactComponent };